import React from 'react'

import { AppSvg, Button, FormattedHTMLMessage, newIcons } from '@web/walter-ui-kit'
import s from './s.module.css'
import { lang } from './lang'
import ModalView from '~components/ModalView'

interface Props {
    onClose: () => void
}

function Success({ onClose }: Props) {
    return (
        <ModalView
            img={
                <div className={s.icon}>
                    <AppSvg svgName={newIcons.ic80Check} size={80} path="new-icons" />
                </div>
            }
            title={<FormattedHTMLMessage {...lang.title} />}
            subtitle={<FormattedHTMLMessage {...lang.subtitle} />}
            dataPointer="freeze_success"
        >
            <Button dataPointer="button" size="l" mode="primary" onClick={onClose} fullWidth>
                <FormattedHTMLMessage {...lang.button} />
            </Button>
        </ModalView>
    )
}

export default Success
